<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="9.5" fill="currentColor" />
    <path
      d="M10.9444 15.6944H13.3821"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1678 15.6945V11.2083H10.9539"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1056 8.03876C12.1056 8.18451 11.9874 8.30265 11.8417 8.30265C11.6959 8.30265 11.5778 8.18451 11.5778 8.03876C11.5778 7.89302 11.6959 7.77488 11.8417 7.77488"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.8417 7.77489C11.9874 7.77489 12.1056 7.89304 12.1056 8.03878"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
